import { getCookie } from 'util/cookie-util';

import axios from 'axios';
import type { CartItem } from 'types';

const magentoMergeToCard = async (newItems: CartItem[], path?: string) => {
  const currentTime = Math.round(Date.now() / 1000);
  const sectionDataIds = encodeURI(
    JSON.stringify({ 'bss-fbpixel-atc': currentTime, cart: currentTime, 'directory-data': currentTime })
  );
  document.cookie = `section_data_ids=${sectionDataIds}`;

  for (const cartItem of newItems) {
    const { qty, variantId } = cartItem;
    const data = new FormData();
    data.append('qty', qty);
    data.append('form_key', getCookie('form_key')!);
    const config = {
      accept: 'application/json, */*; q=0.01',
      'content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      data: data,
      method: 'post',
      url: path ? `${path}/checkout/cart/add/product/${variantId}/` : `/checkout/cart/add/product/${variantId}/`
    };
    await axios(config);
  }
  const item = localStorage.getItem('mage-cache-storage');
  if (item) {
    const mageCache = JSON.parse(item);
    delete mageCache.cart;
    localStorage.setItem('mage-cache-storage', JSON.stringify(mageCache));
  }
  localStorage.removeItem('mage-cache-timeout');
};
export default magentoMergeToCard;
